export const FORGOT_PASSWORD_ROUTE = '/forgotPassword';
export const MESSAGE_PAGE_ACCOUNTLOCKED_ROUTE = '/messageLocked';
export const MESSAGE_PAGE_ROUTE = '/message';
